<div class="w-100">
  <div class="dialog-header justify-content-center border-0 p-4">
    <!-- <button
      type="button"
      aria-label="Close"
      class="btn-close"
      (click)="onClose()"
    ></button> -->
  </div>
  <div class="dialog-content py-6 pt-8">
    <div class="row py-4 justify-content-center text-center">
      <app-keenicon name="book-open" class="fs-4x"></app-keenicon>
      <div class="fs-1 fw-semibold pt-2 text-gray-900">
        {{ "ONLINE_CLASS.ACTIVE_CONFIRM" | translate }}
      </div>

      <!-- <p class="fs-1 fw-bold">ยืนยันการเปิดคอร์สเรียน</p> -->
      <p class="fs-3 text-gray-800 mb-0">
        {{ "ONLINE_CLASS.ACTIVE_CONFIRM_DESC" | translate }}
      </p>
    </div>
  </div>
  <div class="dialog-footer flex-center border-0 gap-8 pb-8">
    <div class="row w-100">
      <div class="col-6">
        <button
          type="reset"
          class="btn btn-outline-light border col-12"
          (click)="onClose()"
        >
          {{ "COMPONENT.CANCEL" | translate }}
        </button>
      </div>
      <div class="col-6">
        <button class="btn btn-primary col-12" (click)="onConfirm()">
          {{ "COMPONENT.CONFIRM" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
